import React from "react";
import AdmStudentGrievances from "../../components/AdminTabs/AdminStudentGrievances/AdmStudentGrievances";

const AddStudent = () => {
  return (
    <div>
      <AdmStudentGrievances/>
    </div>
  );
};

export default AddStudent;
